<app-search-bar
  [keyword]="keyword"
  (keywordChange)="onKeywordChange($event)"
  [disabled]="disabled"
  [isButtonTrigger]="true"
  [maxLength]="maxLength"
  [maxKeywords]="maxKeywords"
  (userInteracting)="onUserInteracting($event)"
  [mobileViewIconOnly]="true"
></app-search-bar>
